export default __webpack_public_path__ + "static/media/ortecso.5b60c495.png";